import React from 'react';
import { ErrorMessage } from '@common/components/ErrorMessage';
import { SingleSelect } from '@common/components/FormElements/SingleSelect';
import { useTranslation } from '@common/hooks/useTranslation';
import { useAppSelector } from '@store/hooks';
import { getBrandName, getLocalisation } from '@store/localisation';
import { Field } from '@components/FormElements';
import { options } from './options';

type Props = {
  value?: string;
  label?: string | React.ReactNode;
  onChange: (key: string) => void;
  error?: string;
  disabled?: boolean;
  businessName?: string;
};

export const VideoQuestionsField = ({
  value,
  disabled,
  label,
  onChange,
  error,
  businessName
}: Props) => {
  const { t } = useTranslation();
  const { countryCode } = useAppSelector(getLocalisation);
  const brand = useAppSelector(getBrandName);

  return (
    <div className="flex flex-col gap-3 z-10 relative">
      <Field
        label={label || t('postJobForm.fieldLabel.videoScreeningQuestion')}
        message={
          error && (
            <div className="mt-sm">
              <ErrorMessage>{error}</ErrorMessage>
            </div>
          )
        }
      >
        <div className="mt-sm">
          <SingleSelect<string>
            testID="job-form-videoScreeningQuestions"
            disabled={disabled}
            onChange={onChange}
            options={options({
              t,
              brand: brand!,
              countryCode: countryCode!,
              params: {
                businessName: businessName!
              }
            })}
            value={value}
          />
        </div>
      </Field>
    </div>
  );
};
